angular.module('cvsApp').controller('commonPopUpController', function ($scope,$uibModalInstance,parentScope,$rootScope) {
	$scope.parentScope=parentScope;
	angular.module('cvsApp').modalInstance=$uibModalInstance;
	
	
	$scope.closePopUP=function(button,id){
		if(cvsUtility.setNativeCheck()){
			try{
            native.enableHeader();
			}catch(ex){}
        } 
		
		if(typeof parentScope.closePopUP === 'function')
			parentScope.closePopUP(button,id);		
		$uibModalInstance.close();
	}

	$scope.cancelPopUP=function(){
		
		if(typeof parentScope.cancelPopUP === 'function')
			parentScope.cancelPopUP();		
		$uibModalInstance.close();
	}

	$scope.doPurpose = function(button){
		
		if(typeof parentScope.doPurpose === 'function')
			parentScope.doPurpose(button);		
		$uibModalInstance.close();
	}
	$scope.promotionGo = function(){
		if(typeof parentScope.promotionGo === 'function')
			parentScope.promotionGo();
		$scope.closePopUP();
	}

	

});